const rptracker = (window.rptracker != undefined) ? window.rptracker : {track: function(){ console.log('rptracker could not load') }};

export default rptracker;